/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function IsPc() {
  return document.body.clientWidth > 768
}

function throttle(fn, timeout) {
  let isPending = false
  return (...arg) => {
    if (isPending) return
    isPending = true
    fn(...arg)
    setTimeout(() => {
      isPending = false
    }, timeout)
  }
}

function debounce(fn, wait) {
  var timeout = null
  return (...arg) => {
    if (timeout !== null) clearTimeout(timeout)
    timeout = setTimeout(fn.bind(this, ...arg), wait)
  }
}

function elementInView(element) {
  const rect = element.getBoundingClientRect()
  const yInView = rect.top < window.innerHeight && rect.bottom > 0
  // const xInView = rect.left < window.innerWidth && rect.right > 0
  return yInView
}

class CollectionCarousel {
  currentIndex = 1
  positionList = [
    {
      transform: 'scale(0.85) translate(-150vw)',
      zIndex: '-2',
    },
    {
      transform: 'scale(0.85) translate(-90vw, 0)',
      zIndex: '-1',
    },
    {
      transform: 'scale(0.85)',
      zIndex: '2',
    },
    {
      transform: 'scale(0.85) translate(90vw, 0)',
      zIndex: '-1',
    },
    {
      transform: 'scale(0.85) translate(150vw)',
      zIndex: '-2',
    },
  ]
  // positionList = [
  //   {
  //     transform: "scale(0.7) translate(-150vw)",
  //     zIndex: "0"
  //   },
  //   {
  //     transform: "scale(0.7) translate(-70vw, 0)",
  //     zIndex: "1"
  //   },
  //   {
  //     transform: "scale(0.85)",
  //     zIndex: "2"
  //   },
  //   {
  //     transform: "scale(0.7) translate(70vw, 0)",
  //     zIndex: "1"
  //   },
  //   {
  //     transform: "scale(0.7) translate(150vw)",
  //     zIndex: "0"
  //   },
  // ]

  //当前在轮播的对象
  currentItems = []
  clickEventList = []
  updateEventId
  autoPlayId
  options = {
    duration: 1000,
    autoPlay: null,
  }

  constructor(wrapper, items, options) {
    this.wrapper = wrapper
    this.options = {
      ...this.options,
      ...options,
    }
    this.items = Array.from(this.clone(items)).map((el, index) =>
      $(el)
        .css({
          position: 'absolute',
          left: '0',
          transition: `${this.options.duration}ms all`,
        })
        .attr('data-index', index)
    )
    this.initDom()
    this.initEvent()
  }

  clone(items) {
    if (items.length <= 3) {
      items.push(...items.clone())
      return this.clone(items)
    } else return items
  }

  initDom() {
    // const ul=document.createElement("ul");
    // ul.classList.add('Carousel_dot_wrap')
    // this.wrapper.append(ul)
    this.items.forEach((el) => {
      this.wrapper.append(el.hide())
    })
    this.currentItems = [
      this.getItem(this.currentIndex - 1),
      this.getItem(this.currentIndex),
      this.getItem(this.currentIndex + 1),
    ]
    this.currentItems.forEach((el, index) => {
      el.css(this.positionList[index + 1]).show()
      // ul.innerHTML += `<li class="Carousel_dot ${this.currentIndex === index && 'Carousel_dot_active'}"></li>`
    })
    this.wrapper.height(this.items[this.currentIndex].height() * 0.9)
  }

  initEvent() {
    this.wrapper.find('.arrow-label-left').click(() => {
      this.clickEventList.push(this.slideRight)
    })
    this.wrapper.find('.arrow-label-right').click(() => {
      this.clickEventList.push(this.slideLeft)
    })

    const updateEvent = async () => {
      if (elementInView(this.wrapper[0])) {
        if (this.clickEventList.length > 0) {
          this.cancelAutoPlay()
          await this.clickEventList.shift().call(this)
        } else {
          this.startAutoPlay()
        }
      } else {
        this.cancelAutoPlay()
      }
      this.updateEventId = requestAnimationFrame(updateEvent)
    }
    updateEvent()
  }

  startAutoPlay() {
    if (this.options.autoPlay && !this.autoPlayId) {
      this.autoPlayId = setInterval(() => {
        this.slideLeft()
      }, this.options.autoPlay)
    }
  }

  cancelAutoPlay() {
    if (this.autoPlayId) {
      clearInterval(this.autoPlayId)
      this.autoPlayId = null
    }
  }

  getItem(index) {
    const length = this.wrapper.find('ul').children().length
    let realIndex = this.getRealIndex(index)
    // if (length) {
    //   Array.from(this.wrapper.find("ul").children()).forEach(e => {
    //     e.classList.remove('Carousel_dot_active')
    //   })
    // }
    return this.items[this.getRealIndex(index)]
  }

  getRealIndex(index) {
    const length = this.items.length
    // ${this.currentIndex === index+1 && 'Carousel_dot_active'}
    let realIndex = 0
    if (index < 0) realIndex = this.getRealIndex(index + length)
    else if (index >= length) realIndex = index % length
    else realIndex = index
    return realIndex
  }

  slideRight() {
    return new Promise((resolve) => {
      const nextItem = this.getItem(this.currentIndex - 2)
        .css(this.positionList[0])
        .show()
      this.currentItems.unshift(nextItem)
      this.currentItems.forEach((el, index) => {
        el.css(this.positionList[index + 1])
      })
      setTimeout(() => {
        this.currentIndex = this.getRealIndex(this.currentIndex - 1)
        // this.wrapper.find("ul").children()[this.currentIndex%3].classList.add('Carousel_dot_active')
        this.currentItems.pop().hide()
        resolve(this)
      }, this.options.duration)
    })
  }

  slideLeft() {
    return new Promise((resolve) => {
      const nextItem = this.getItem(this.currentIndex + 2)
        .css(this.positionList[4])
        .show()
      this.currentItems.push(nextItem)
      this.currentItems.forEach((el, index) => {
        el.css(this.positionList[index])
      })
      setTimeout(() => {
        this.currentIndex = this.getRealIndex(this.currentIndex + 1)
        // this.wrapper.find("ul").children()[this.currentIndex%3].classList.add('Carousel_dot_active')
        this.currentItems.shift().hide()
        resolve(this)
      }, this.options.duration)
    })
  }
}
